// extracted by mini-css-extract-plugin
module.exports = {"borderless":"style-module--borderless--38yz9"};